// TODO USE clientConfig | serverConfig instead this file
import { clientConfig } from '@/config/clientConfig';
/**
 * @deprecated Use clientConfig
 */
export const isExported = clientConfig.isExported;
/**
 * @deprecated Use clientConfig
 */
export const isExportedDemo = clientConfig.demoHub.isDemoHub;
/**
 * @deprecated Use clientConfig
 */
export const INBOX_EMAIL_DOMAIN = `@${process.env.NEXT_PUBLIC_INBOX_EMAIL_DOMAIN}`;
/**
 * @deprecated Use clientConfig
 */
export const DEFAULT_PROFILE_BASE_CURRENCY = 'USD';
/**
 * @deprecated Use clientConfig
 */
export const API_COLLECTION_PLATFORM_KEY = 'web';
/**
 * @deprecated Use clientConfig
 */
export const demoHubMnemonic = process.env.NEXT_PUBLIC_DEMO_HUB_SEED_PHRASE;
/**
 * @deprecated Use clientConfig
 */
export const appOrigin = process.env.NEXT_PUBLIC_SELF_URL_BASE;
export const IOS_APP_LINK = 'https://apps.apple.com/lt/app/owner-one/id6473855308';
export const ANDROID_APP_LINK =
  'https://play.google.com/store/apps/details?id=one.owner.app.android&hl=en';
